import styled from 'styled-components';
import React, {FC} from 'react';

import {palette, fontSizesMixins} from '../../../../lib/styleVariables';
import {Icon} from '../../../molecules/icon';
import {StyledLeftMenuButton} from './headerMenu';
import {hasHref, HeaderMenuLeftCallToActionProps, HeaderMenuLeftSubItemProps} from './headerMenuTypes';
import {StyledSubMenuListItem, StyledSubMenuListItemIconWrapper} from './headerSubMenu';

const StyledExpandedMobilMenuItemWrapper = styled.div`
  ${fontSizesMixins.text3()};

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

const StyledExpandedMobilMenuItem = styled.div`
  display: flex;
  justify-content: space-between;
`;

const StyledSubMenuWrapper = styled.div`
  padding-top: 8px;
`;

const expandIconStyle = `
  transform: rotate(180deg);
`;

const StyledIcon = styled(Icon)<{isExpanded: boolean}>`
  color: inherit;
  align-self: center;
  ${props => (props.isExpanded ? expandIconStyle : '')}
`;

const styledLeftMenuButtonStyle = `
  width: 100%;
`;

export interface MobileHeaderMenuPrimaryItemProps {
  name: string;
  subMenu?: {
    items: Array<HeaderMenuLeftSubItemProps>;
    callToAction?: HeaderMenuLeftCallToActionProps;
    imageSrc: string;
  };
  href?: string;
}

interface MobileHeaderMenuPrimaryProps {
  item: MobileHeaderMenuPrimaryItemProps;
  locationPath: string;
}

export const MobileHeaderMenuPrimaryItem: FC<MobileHeaderMenuPrimaryProps> = props => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const hasSubItem = !hasHref(props.item);

  return (
    <StyledExpandedMobilMenuItemWrapper>
      <StyledExpandedMobilMenuItem
        onClick={() => {
          if (hasSubItem)
            setIsExpanded(!isExpanded);
        }}
      >
        <StyledLeftMenuButton
          href={hasSubItem ? undefined : props.item.href}
          $css={styledLeftMenuButtonStyle}
        >
          {props.item.name}
        </StyledLeftMenuButton>
        {hasSubItem && <StyledIcon name="chevronExpand" color={palette.black.base} isExpanded={isExpanded} />}
      </StyledExpandedMobilMenuItem>
      {isExpanded && (
        <StyledSubMenuWrapper>
          {props.item.subMenu &&
            props.item.subMenu.items.map(subItem => (
              <StyledSubMenuListItem
                href={subItem.href}
                isLinkActive={props.locationPath === subItem.href}
                key={`${subItem.name}-${subItem.href}`}
              >
                <StyledSubMenuListItemIconWrapper>
                  <Icon name={subItem.iconName} size={24} />
                </StyledSubMenuListItemIconWrapper>
                <span>{subItem.name}</span>
              </StyledSubMenuListItem>
            ))}
        </StyledSubMenuWrapper>
      )}
    </StyledExpandedMobilMenuItemWrapper>
  );
};
